<div class="header-bar" [class.ghost]="job == null">
  <div class="flex flex-wrap grid-gap-10">
    <div class="flex-grow-1 flex grid-gap-10 align-items-center">
      <div class="flex-shrink-1 white-space-nowrap"><i class="fa fa-angle-left"></i> Back</div>

      <div class="flex-shrink-1 incident-icons" *ngIf="job?.priorityDeployment">
        <i
          pTooltip="Priority Deployment Job"
          class="fa fa-exclamation-circle"
          style="color: #c00"
        ></i>
      </div>

      <div class="flex-shrink-1 ghost-inline job-number white-space-nowrap">
        {{ job?.jobNumber }}
      </div>
      <div class="flex-shrink-1 ghost-inline status-chip white-space-nowrap">
        {{ commonService.getStatus(job) }}
      </div>
    </div>
  </div>
</div>
